import React from 'react';
import { UserSettingsSection } from '../../../../configure/panels/sections/UserSettingsSection/UserSettingsSection';

export const Users = () => {
  return <UserSettingsSection />;
};
